module.exports = __webpack_public_path__ + "img/result-index-img02.69c6e080.svg";